import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import {
  PrimaryButton,
  ButtonSizes,
} from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'banner'], {
  shouldEscapeStrings: false,
});

interface UrgentUpdateProps {
  aaEmail: string;
  orgName: string;
  updateByDate: string;
  onDismiss: () => void;
  onClickAccountType: () => void;
}

export const UrgentUpdate: FunctionComponent<UrgentUpdateProps> = ({
  aaEmail,
  orgName,
  onDismiss,
  onClickAccountType,
  updateByDate,
}) => (
  <OnboardingDialog
    title={format('update by', { date: updateByDate })}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss}
    className={styles.urgentUpdateBody}
  >
    <div className={styles.urgentUpdateContent}>
      <p>
        {format('claim msg', {
          orgName,
        })}
        <u>{aaEmail}</u>
      </p>
    </div>
    <div className={styles.urgentUpdateSection}>
      <PrimaryButton
        className={styles.onlyWorkButton}
        onClick={onClickAccountType}
        size={ButtonSizes.WIDE}
      >
        {format('continue')}
      </PrimaryButton>
    </div>
  </OnboardingDialog>
);
